/* tslint:disable:align */
//============================================================================
// Name        : Checkbox.tsx
// Purpose     : Implement custom design checkbox
// Created     : 2020-02-27
// Author      : Senitron Team
// Copyright   : Copyright 2020 Senitron Corporation. All rights reserved.
//============================================================================

// tslint:disable-next-line: no-unused-expression
/** @jsx jsx */ jsx;
import { jsx } from "@emotion/core";
import React from "react";

interface ICheckboxProps {
    name: string;
    label: string;
    checked?: boolean;
    onChange?: (name: string, checked: boolean) => void;
}

interface ICheckboxState {
    checkBoxChecked: boolean;
}

export default class Checkbox extends React.Component<ICheckboxProps, ICheckboxState> {
    constructor(props: any) {
        super(props);

        // Set state from props
        this.state = {
            checkBoxChecked: false || this.props.checked
        };
    }

    onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const newState = { checkBoxChecked: event.target.checked };
        this.setState(newState);
        if (this.props.onChange) {
            this.props.onChange(this.props.name, event.target.checked);
        }
    }

    render() {
        return (
            <div className="checkbox">
                <label>
                    <input type="checkbox" name={this.props.name} checked={this.state.checkBoxChecked} onChange={this.onChange} />
                    <span className="cr"><i className="cr-icon fa fa-check"></i></span>
                    <span>{this.props.label}</span>
                </label>
            </div>
        );
    }
}
